<div class="mdl-grid" ng-if="ctrl.mode === 0">
  <h5 class="mdl-layout-title">{{::ctrl.labelUploadTitle | translate}}</h5>
  
  <div class="mdl-cell mdl-cell--12-col" ng-if="ctrl.showUpload">
    <md-card>
      <md-card-content ng-if="$root.permisos.DOCUMENT.edit" >
        <adm-form-file-upload-manteniment
          id-type-document="ctrl.idTypeDocument"
          select-files-text="SHARED_DOCUMENT_UPLOAD_SELECT_FILES"
          save-files-text="SHARED_DOCUMENT_UPLOAD_SAVE_FILES"
          max-size-exceeded-text="SHARED_DOCUMENT_UPLOAD_MAX_SIZE_EXCEEDED"
          id-entitat="idEntitat"
          on-finish-function="ctrl.uploadEndFunction()"
          url-base="baseUrlUpload"
          url-controller="controllerUrlUpload">
        </adm-form-file-upload-manteniment>
      </md-card-content>
    </md-card>
  </div>

  <div class="mdl-cell mdl-cell--11-col">
    <h5 class="mdl-layout-title">{{::ctrl.labelListTitle | translate}}</h5>
  </div>

 <!-- <div class="mdl-cell mdl-cell--1-col">
    <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored" ng-click="ctrl.changeListMode()">
      <i ng-if="ctrl.listMode" class="material-icons" title="{{'DEFAULT_ACCIONS_VISUALITZAR_ICONES' | translate}}" aria-label="{{'DEFAULT_ACCIONS_VISUALITZAR_ICONES' | translate}}">view_comfy </i>
      <i ng-if="!ctrl.listMode" class="material-icons" title="{{'DEFAULT_ACCIONS_VISUALITZAR_LLISTA' | translate}}" aria-label="{{'DEFAULT_ACCIONS_VISUALITZAR_LLISTA' | translate}}">format_list_bulleted</i>
    </button> 
  </div> -->

  <div class="mdl-cell mdl-cell--12-col">
    <md-card>
      <md-card-content>
        <table class="itec-table">
          <thead>
            <tr>
              <th class="maxwidthTableButton"></th>
              <th>
                <ng-pluralize count="listDocuments.length"
                  when="{'0': '{{&quot;SHARED_DOCUMENT_UPLOADED_COUNT_0&quot; | translate}}',
                      '1': '{{&quot;SHARED_DOCUMENT_UPLOADED_COUNT_1&quot; | translate}}',
                      'other': '{{&quot;SHARED_DOCUMENT_UPLOADED_COUNT_N&quot; | translate:{count : listDocuments.length} }}'}">
                </ng-pluralize>
              </th>
              <th class="maxwidthTableButton">
  	            <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored" ng-click="ctrl.downloadDocuments(ctrl.selectedDocuments)" title="{{'DEFAULT_ACCIONS_DESCARREGAR' | translate}}" aria-label="{{'DEFAULT_ACCIONS_DESCARREGAR' | translate}}">
  	              <i class="material-icons">file_download</i>
  	            </button>     
              </th>
              <th class="maxwidthTableButton">
  	            <button ng-if="$root.permisos.DOCUMENT.edit" class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored"
  	                itec-dialog-confirm 
                    itec-dialog-confirm-title="SHARED_DOCUMENT_CONFIRM_DELETE_TITLE"
                    itec-dialog-confirm-text-content="{{ctrl.labelConfirmDelete}}"
					title="{{'DEFAULT_ACCIONS_ESBORRAR' | translate}}" 
                    aria-label="{{'DEFAULT_ACCIONS_ESBORRAR' | translate}}"
                    itec-dialog-confirm-text-ok="DEFAULT_ESBORRAR"
                    itec-dialog-confirm-text-cancel="DEFAULT_CANCELAR"
                    itec-dialog-confirm-function-ok="ctrl.deleteDocuments(ctrl.selectedDocuments)"
                    ng-if="ctrl.showDelete">
  	              <i class="material-icons">delete</i>
  	            </button>   
              </th>
            </tr>
          </thead>
          <tbody ng-if="!ctrl.listMode">
            <tr>
              <td colspan="9">
                <itec-gallery ng-if="!ctrl.listMode" list="listDocuments" selected="ctrl.selectedDocuments" property-label="titol" property-date="dataDocument"></itec-gallery>
              </td>
            </tr>
          </tbody>
          <tbody ng-if="ctrl.listMode">
            <tr ng-repeat="doc in listDocuments">
              <td ng-if="doc.predeterminat">
                <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored" ng-click="" ng-if="ctrl.showEdit">
                  <i class="material-icons">star</i>
                </button>
                <button class="mdl-button mdl-js-button mdl-button--icon" ng-click="" ng-if="!ctrl.showEdit">
                  <i class="material-icons">star</i>
                </button>
              </td>
              <td ng-if="!doc.predeterminat">
                <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored" ng-click="ctrl.editDocument(doc.id)" ng-if="ctrl.showEdit">
                  <i class="material-icons">star_border</i>
                </button>
                <button class="mdl-button mdl-js-button mdl-button--icon" ng-click="" ng-if="!ctrl.showEdit">
                  <i class="material-icons">star_border</i>
                </button>
              </td>
              <td>
                {{doc.nom}}
              </td>
              <td> 
                <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored" ng-click="ctrl.downloadDocument(doc.id)">
                  <i class="material-icons">file_download</i>
                </button>     
              </td>
              <td>
                <button ng-if="$root.permisos.DOCUMENT.edit" class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored"
                    itec-dialog-confirm 
                    itec-dialog-confirm-title="SHARED_DOCUMENT_CONFIRM_DELETE_TITLE"
                    itec-dialog-confirm-text-content="{{ctrl.labelConfirmDelete}}"
		                itec-dialog-confirm-text-ok="DEFAULT_ESBORRAR"
                    itec-dialog-confirm-text-cancel="DEFAULT_CANCELAR"
                    itec-dialog-confirm-function-ok="ctrl.deleteDocument(doc.id)"
                    ng-if="ctrl.showDelete">
                  <i class="material-icons">delete</i>
                </button>   
              </td>
            </tr>
          </tbody>
        </table>
      </md-card-content>
    </md-card>
  </div>
</div>

<div class="mdl-grid" ng-if="ctrl.mode === 1">
  <h5 class="mdl-layout-title">{{::ctrl.labelEditTitle | translate}}</h5>

  <div class="mdl-cell mdl-cell--12-col">
    <md-card>
      <md-card-content>

        <form name="ctrl.editForm" novalidate ng-cloak>
          <div class="mdl-grid" ng-repeat="editDocument in ctrl.listEditDocuments">
            <div class="mdl-cell mdl-cell--6-col">
              <itec-input-text
                name="{{editDocument.id}}.nom"
                ng-model="editDocument.nom"
                ng-required="true"
                ng-minlength="0"
                ng-maxlength="100"
                label="DEFAULT_NOM"
                validation-message-required="DEFAULT_VALIDATION_MESSAGE_REQUIRED"
                validation-message-minlength="DEFAULT_VALIDATION_MESSAGE_MINLENGTH"
                validation-message-maxlength="DEFAULT_VALIDATION_MESSAGE_MAXLENGTH">
              </itec-input-text>

              <itec-error-form errors="ctrl.errors[editDocument.id+'.titol']">
              </itec-error-form>
	          </div>
	          <div class="mdl-cell mdl-cell--6-col"></div>

            <div class="mdl-cell mdl-cell--12-col">
              <itec-error-form errors="ctrl.errors[editDocument.id]">
              </itec-error-form>
            </div>


	          <div class="mdl-cell mdl-cell--12-col">
	            <itec-button label="DEFAULT_GUARDAR"
	              ng-click-function="ctrl.submitEditForm()"
	              ng-disabled="ctrl.editForm.$invalid">
	            </itec-button>
	
	            <itec-button label="DEFAULT_TORNAR" ng-click-function="ctrl.tornar(0)"></itec-button>
	          </div>
          </div>
        </form>
      </md-card-content>
    </md-card>
  </div>
</div>

<div class="mdl-grid" ng-if="ctrl.mode === 2">
  <h5 class="mdl-layout-title">{{::ctrl.labelVersionTitle | translate}}</h5>
  
  <div class="mdl-cell mdl-cell--12-col">
    <md-card>
      <md-card-content>
        <div class="mdl-grid mdl-grid--no-spacing">
          <div ng-repeat="versionDocument in ctrl.listVersionDocuments" class="mdl-cell mdl-cell--12-col">
            <h6>{{versionDocument.titol}}</h6>
            <table class="itec-table">
              <thead>
              <tr>
                <th>{{::'DEFAULT_DATA_PUBLICACIO' | translate}}</th>
                <th>{{::'DEFAULT_USUARI' | translate}}</th>
                <th>{{::'DEFAULT_VERSIO' | translate}}</th>
                <th>{{::'DEFAULT_ACCIONS' | translate}}</th>
              </tr>
              </thead>
              <tbody>
                <tr ng-repeat="version in versionDocument.versions">
                  <td>{{::version.dataPublicacio | date}}</td>
                  <td>{{::version.usuariPublicacio}}</td>
                  <td>{{::version.versio}}</td>
                  <td>
                    <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored" ng-click="ctrl.downloadDocument(version.id)">
                      <i class="material-icons">file_download</i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <div class="mdl-cell mdl-cell--12-col">
            <div class="horizontal_separator"></div>
            <itec-button label="DEFAULT_TORNAR" ng-click-function="ctrl.tornar(0)"></itec-button>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</div>

<div class="mdl-grid" ng-if="ctrl.mode === 3">

  <h5 class="mdl-layout-title">{{::ctrl.labelLogTitle | translate}}</h5>
  
  <div class="mdl-cell mdl-cell--12-col">
    <md-card>
      <md-card-content>
        <div class="mdl-grid mdl-grid--no-spacing">
          <div ng-repeat="logDocument in ctrl.listLogDocuments" class="mdl-cell mdl-cell--12-col">
            <h6>{{::logDocument.titol}}</h6>
            <table class="itec-table">
              <thead>
              <tr>
                <th>{{::'DEFAULT_DATA' | translate}}</th>
                <th>{{::'DEFAULT_USUARI' | translate}}</th>
                <th>{{::'DEFAULT_VERSIO' | translate}}</th>
                <th>{{::'DEFAULT_DESCRIPCIO' | translate}}</th>
              </tr>
              </thead>
              <tbody>
                <tr ng-repeat="log in logDocument.logs">
                  <td>{{::log.dataLog | date}}</td>
                  <td>{{::log.usuariLog}}</td>
                  <td>{{::log.versioDocument}}</td>
                  <td>{{::log.descripcioLog}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <div class="mdl-cell mdl-cell--12-col">
            <div class="horizontal_separator"></div>
            <itec-button label="DEFAULT_TORNAR" ng-click-function="ctrl.tornar(0)"></itec-button>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</div>